import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { CreateAllocatedBalance } from 'src/app/models/balance';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { CentroCusto } from 'src/app/models/centro-custo';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-saldo-alocado-create',
  templateUrl: './saldo-alocado-create.component.html',
  styleUrls: ['./saldo-alocado-create.component.css']
})
export class SaldoAlocadoCreateComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private balanceService: BalanceService,
        private contratoService: ContratoService,
        private centroCustoService: CentroCustoService,
        private authenticationService: AuthenticationService,
    ) { }

    public currentUser: Auth;
    public produtosList: CedenteContrato[];
    public centrosCustosList: CentroCusto[];

    public allocatedBalanceFormGroup: FormGroup;

    public otherProductsRequired = false;

    public get form() {
        return this.allocatedBalanceFormGroup.controls;
    }

    ngOnInit(): void {
        this.currentUser = this.authenticationService.currentUserValue;
        this.createForm(new CreateAllocatedBalance);

        this.carregarLista();
    }

    createForm(allocatedBalance: CreateAllocatedBalance) {
        this.allocatedBalanceFormGroup = this.formBuilder.group({
        name: new FormControl(allocatedBalance.name, [
            Validators.required,
            Validators.maxLength(100)
        ]),
        costCenterId: new FormControl(allocatedBalance.costCenterId, [
            Validators.required,
        ]),
        principalProductId: new FormControl(allocatedBalance.principalProductId, [
            Validators.required,
        ]),
        products: new FormControl(allocatedBalance.products, [])
        });
    }

    carregarLista() {
        this.contratoService.getAll(this.currentUser.token.assignorGuid).subscribe(
        response => {
            this.produtosList = response.result;
        });

        this.centroCustoService.getAll(this.currentUser.token.assignorGuid).subscribe(
        response => {
            this.centrosCustosList = response.result;
        });
    }

    onSubmit(allocatedBalance: CreateAllocatedBalance) {

        if (this.allocatedBalanceFormGroup.valid) {
        allocatedBalance.assignorGuid = this.currentUser.token.assignorGuid
        this.balanceService.createAllocatedBalance(this.currentUser.token.assignorGuid, allocatedBalance).subscribe(
            response => {
            if (response.status === ApiError.Sucesso) {
                this.alertService.success(response.message, true);
                this.router.navigate(['list'], { relativeTo: this.route.parent });
            } else {
                this.alertService.error(response.message);
            }
            },
            error => {
            this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
            }
        );
        } else {
        GenericValidator.verifierValidatorsForm(this.allocatedBalanceFormGroup);
        }
    }

    onItemSelect(value: any){

        const productCategory = this.produtosList.find(x=>x.produtoElegibilidade.produto.produtoId == value).produtoElegibilidade.produto.produtoCategoria;

        if(productCategory == 7){
            this.allocatedBalanceFormGroup.controls.products.setValidators([Validators.required]);
            this.otherProductsRequired = true;
        }
        else{
            this.allocatedBalanceFormGroup.controls.products.clearValidators();
            this.otherProductsRequired = false;
        }

        this.allocatedBalanceFormGroup.controls.products.updateValueAndValidity();

    }

    navigateToList(){
        this.router.navigate(['list'], { relativeTo: this.route.parent });
    }
}
